<template>
  <div class="animated fadeIn">


    <CreditCardResponse
      v-bind:show.sync="modalCreditCardResponse"
      :title="creditErrorResponse ? 'Error al añadir Método de Pago': 'Método de pago añadido'"
      :confirmText="creditErrorResponse ? 'Inténtalo de nuevo': 'Continuar'"
      :errorResponse="creditErrorResponse"
      @cancel="modalCreditCardResponse = $event"
      @confirm="modalCreditCardResponse = false"
    >
      <template v-if="creditErrorResponse">
        <h2>¡Oops!</h2>
        <p>Algo ha ocurrido, error al añadir el método de pago. Inténtalo de nuevo o ponte en contacto con tu entidad bancaria</p>
      </template>

      <template v-else>
        <h2>¡Listo!</h2>
        <p>Método de pago confirmado, puedes reanudar la contratación</p>
      </template>
    </CreditCardResponse>


    <div class="mb-5 mt-4 text-center">
      <h1><strong>Encuentra tu parking mimoto</strong></h1>

      <p class="text-primary search-subtititle">
        Estaciona tranquilo. Plazas diseñadas para motos, bicicletas y patinetes sin rampas y con taquillas para tu equipamiento.  Abiertos 24h.
      </p>
    </div>


    <EmailValidateAlert v-if="emailNoValidated" />
    <PhoneValidateAlert v-if="phoneNoValidated" />
    <CreditCardValidateAlert v-if="creditCardNoValidated"/>


    <ParkingFilter @getData="searchItems" />
    <spinner-ttt :show="loading"></spinner-ttt>

    <ListaParkings
      v-bind:parkings.sync="items"
      :title="'Listado de Parkings'"
      :loading="loading"
      :rows="pagination.rows"
      :perPage="pagination.perPage"
      :totalPaginas="pagination.total_paginas"
      :currentPage="pagination.currentPage"
      @cambiarPagina="cambiarPagina"
      :sizeHeight="size"
     />

    <toast ref="toast"></toast>
  </div>
</template>

<script>

import { fetchAllParkingsSearch } from "@/app/shared/global/services/parking-service";
import { getLoggedClient } from '@/app/views/auth/shared/services';
import  { noEmail, noCreditCard, noPhone } from '@/app/shared/utils/utils';

export default {
  name: "MainParkings",
  components: {
    ListaParkings: () => import('../components/ListaParkings'),
    ParkingFilter: () => import('../components/BuscardorParking'),
    CreditCardResponse: () => import('@/app/shared/components/modals/CreditCardResponse'),
    EmailValidateAlert: () => import('@/app/shared/components/EmailValidateAlert'),
    PhoneValidateAlert: () => import('@/app/shared/components/PhoneValidateAlert'),
    CreditCardValidateAlert: () => import('@/app/shared/components/CreditCardValidateAlert')
  },
  data() {
    return {
      items: [],
      loading: true,
      filtroOptions: '',

      pagination: {
        pagina_actual: 1,
        rows: 0,
        total_paginas: 1,
        currentPage: this.pagina_actual,
        perPage: 25,
      },

      modalCreditCardResponse: false,
      creditErrorResponse: false,
      windowHeight: null,
      windowWidht: null,
      size: '600px',
      client: null

    };
  },

  created(){
    this.getClientLogged();

    this.getAllParkings();
   
  },

  mounted() {

    this.windowHeight = window.innerHeight;
    this.windowWidht = window.innerWidth;

    this.size = window.innerHeight > 991 ? '800px' : '600px'; // + 946   1335

    if (this.$route.query.ok){
      this.creditErrorResponse = false;
      this.modalCreditCardResponse = true;
      // this.$refs.toast.showToast('Tarjeta procesada correctamente', null,"success","5000");
    }

    if (this.$route.query.ko) {
      this.creditErrorResponse = true;
      this.modalCreditCardResponse = true;
      // this.$refs.toast.showToast('Ha ocurrido un error al añadir la tarjeta', null,"error","5000");
    }
  },
  computed: {
    emailNoValidated(){
      return noEmail(this.client); 
    },
    phoneNoValidated() {
      return noPhone(this.client); 
    },
    creditCardNoValidated() {
      return noCreditCard(this.client);
    },

    emailValidated(){
      if (this.client) 
        return Boolean(this.client.email_verified_at);
      return true
    },
    phoneValidated() {
      if (this.client)
        return Boolean(this.client.phone_verified)
      return true
    },
    creditCardValidated() {
      if (this.client && this.client.credit_cards)
        return this.client.credit_cards.length > 0
      return true
    },




  },
  methods: {
    searchItems(filter) {
      this.filtroOptions = filter;
      this.pagination.pagina_actual = 1;
      this.getAllParkings();
    },


    getAllParkings( ) {

      this.loading = true;
      const errorMessage = 'Error al listar los parkings';

      // Obtener info para el semáfono de ocupación
      this.filtroOptions += '&withOcupation=1';


      // page: this.pagination.pagina_actual,
      fetchAllParkingsSearch({filtro: this.filtroOptions})
        .then( async (resp) => {

          if ( resp.status !== 'success' ){
            this.$refs.toast.showToast(errorMessage, null, 'error', '2000');
            this.loading = false;
            return
          }

          this.items = [...resp.data];

          // this.pagination = apiTools.getPaginationData(resp.data);

          this.loading = false;
        })
        .catch((e) => {
          // console.log(e);

          this.$refs.toast.showToast(errorMessage, null,"error","2000");
          this.loading = false;
        });
    },

    cambiarPagina(e) {
      this.pagination.pagina_actual = e;
      this.getAllParkings();
    },

    async getClientLogged() {
      try {

        let resp = await getLoggedClient();

        if (resp.status !== 'success') {
          return
        }

        this.client = resp.data;

      }catch(e) {
        console.log(e);
      }
    },


  },
};
</script>
